import React from "react";
import AnimatedFeatureSection from "../../component/common/AnimatedFeatureSection";

const WhyChooseUsSection = () => {
  // Define the specific data for this section
  const featuresData = [
    {
      icon: "/images/aboutImg/icon1.svg",
      title: "100% Eco-Friendly & Sustainable Solutions",
      // description:
      //   "We prioritize environmental sustainability in all our products and processes.",
      // The unique margins are passed here via className
      className: "mb-[38px] 2xl:mb-[76px]",
    },
    {
      icon: "/images/aboutImg/icon2.svg",
      title: "Cost-Effective & Efficient Energy Solutions",
      // description:
      //   "Our bio gas solutions provide a reliable and affordable alternative to conventional energy sources.",
      className: "", // No margin
    },
    {
      icon: "/images/aboutImg/icon3.svg",
      title: " Production of high-quality organic fertilizers for soil health ",
      // description:
      //   "We adhere to strict quality control measures to ensure the safety and efficacy of our offerings.",
      className: "mb-[19px] 2xl:mb-[38px]",
    },
    {
      icon: "/images/aboutImg/icon4.svg",
      title: "Supporting Farmers & Industries in Green Transformation",
      // description:
      //   "From soft skills to technical knowledge, we help you upskill and stay ahead.",
      className: "mb-[40px] 2xl:mb-[80px]",
    },
  ];

  return (
    <AnimatedFeatureSection
      subtitle="Offering"
      title="Why Choose Us?"
      features={featuresData}
      // Optional: Overrides (defaults are already set to your original colors)
      bgColor="bg-[#1C233A]"
      textColor="text-text-secondary"
      lineColor="bg-text-secondary"
    />
  );
};

export default WhyChooseUsSection;
